var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-datepicker',{class:{ 'is-error': _vm.showError },attrs:{"placeholder":_vm.placeholderText,"size":_vm.size,"disabled":_vm.disabled,"date-format-options":{
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
        }},on:{"input":_vm.handleDateInput},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }